import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useEffect } from 'react';
import { Button, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Table } from 'reactstrap';
import './GridBoard.css'
// import PropTypes from 'prop-types';
import extensionsApi from '../apis/extensionsApi';
import { useState } from 'react';

// GridBoard.propTypes = {
    
// };

function GridBoard(props) {

    const lsGroupSelected = props.lsGrSelected;

    const [listExtensions, setListExtensions] = useState([]);
    // const [listGroups, setListGroups] = useState([]);
    // const [modalIsOpen, setModalIsOpen] = useState(false);
    const [listGroupChecked, setListGroupChecked] = useState(lsGroupSelected);
    const [currSelectedExts, setCurrSelectedExts] = useState([]);
    const [commonStatistic, setCommonStatistic] = useState({
        totalCall: 0,
        talkingTime: "00:00:00",
        waitingTime: "00:00:00",
        numOfAgentsBusy: 0,
        answeredCalls: 0,
        unansweredCalls: 0
    });
    const [isLoaded, setIsLoaded] = useState(false);
    // const [isCheckAll, setIsCheckAll] = useState(true);
    // const [currTime, setCurrTime] = useState(false);

    useEffect(() => {
        // setCurrTime(new Date());

        // const retrieveAllGroupName = (lsExtensions) => {
        //     let groups = [];
    
        //     for(let ii = 0; ii< lsExtensions.length; ii++) {
        //         for(let jj = 0; jj < lsExtensions[ii].groupName.length; jj++) {
        //             if(!groups.includes(lsExtensions[ii].groupName[jj])) {
        //                 groups.push(lsExtensions[ii].groupName[jj]);
        //             }
        //         }
        //     }
    
        //     console.log("Groups are: ", groups);

        //     // setListGroups(groups);
        //     setListGroupChecked(groups);
        //     setCurrDataMatchGroupsSelected(lsExtensions, groups);

        //     console.log("TUTUTUT: ", lsGroupSelected);

        //     return groups;
        // }

        const fetchExtensions = async () => {
            try {
                const response = await extensionsApi.getAll();

                // console.log("Fetch extensions successfully 2: ", response);

                setListExtensions(response);

                setCurrDataMatchGroupsSelected(response, lsGroupSelected);

                // setIsLoaded(false);
                setIsLoaded(true);

                // retrieveAllGroupName(response);
            } catch (error) {
                // console.log("Failed to fetch extensions: ", error);
                props.onHandleChange(false);
            }
        }


        fetchExtensions();

        const interval = setInterval(() => {
            fetchExtensions();
            setCurrDataMatchGroupsSelected(listExtensions, lsGroupSelected);
        }, 5000);

        return () => clearInterval(interval);
    }, [lsGroupSelected, isLoaded]);


    // const getCurrTime = () => {
    //     setCurrTime(!currTime);
    // }

    // setInterval(getCurrTime, 5000);

    const sumOfTime = (a, b) => {
        const aArr = a.split(":");
        const bArr = b.split(":");

        let valHour = 0;
        let valMin = 0;
        let valSec = 0;

        valSec = parseInt(aArr[2]) + parseInt(bArr[2]);
        if(valSec > 59) {
            valMin++;
            valSec = valSec - 60;
        }

        valMin = valMin + parseInt(aArr[1]) + parseInt(bArr[1]);
        if(valMin > 59) {
            valHour++;
            valMin = valMin - 60;
        }

        valHour = valHour + parseInt(aArr[0]) + parseInt(bArr[0]);

        return valHour + ":" + valMin + ":" + valSec;
    }

    const setCurrDataMatchGroupsSelected = (lsExtensions, groups = listGroupChecked) => {

        let commSta = {
            totalCall: 0,
            talkingTime: "00:00:00",
            waitingTime: "00:00:00",
            numOfAgentsBusy: 0,
            answeredCalls: 0,
            unansweredCalls: 0
        };

        let valTotalCall = 0;
        let valTalkingTime = "00:00:00";
        let valWaitingTime = "00:00:00";
        let valNumOfAgentsBusy = 0;
        let valAnsweredCalls = 0;
        let valUnansweredCalls = 0;

        const tmpCurrExts = [];

        for(let ii = 0; ii < lsExtensions.length; ii++) {
            for(let jj = 0; jj < lsExtensions[ii].groupName.length; jj++) {
                if(groups.includes(lsExtensions[ii].groupName[jj])) {
                    tmpCurrExts.push(lsExtensions[ii]);

                    valTotalCall += lsExtensions[ii].numOfOutbound;
                    valTalkingTime = sumOfTime(valTalkingTime, lsExtensions[ii].outboundTalkingTime);
                    valWaitingTime = sumOfTime(valWaitingTime, lsExtensions[ii].outboundRingingTime);
                    valNumOfAgentsBusy += (lsExtensions[ii].externalPartyNumbers.length > 0 ? 1 : 0);
                    valAnsweredCalls += lsExtensions[ii].numOfOutboundAnswered;
                    valUnansweredCalls += lsExtensions[ii].numOfOutboundUnanswered;
                    break;
                }
            }
        }

        commSta = {
            totalCall: valTotalCall,
            talkingTime: valTalkingTime,
            waitingTime: valWaitingTime,
            numOfAgentsBusy: valNumOfAgentsBusy,
            answeredCalls: valAnsweredCalls,
            unansweredCalls: valUnansweredCalls
        };

        setCommonStatistic(commSta);

        // console.log("Set Ext Selected: ", tmpCurrExts);
        
        setCurrSelectedExts(tmpCurrExts);
        return tmpCurrExts;
    }

    const bindStatusColorFromStatusText = (statusText) => {
        let colorText = 'green';

        if(statusText === 'Available') {
            colorText = 'green';
        } else if(statusText === 'Busy') {
            colorText = 'red';
        } else if(statusText === 'Away') {
            colorText = 'yellow';
        } else if(statusText === 'Out of office') { // Do not disturb
            colorText = 'orange';
        } else if(statusText === 'Custom 1') {  // Lunch
            colorText = '#a4fa74';
        } else if(statusText === 'Custom 2') {  // Business Trip
            colorText = '#d16351';
        }

        return colorText;
    }

    // const genCheckBox = () => {
    //     const items = [];
    //     for(let i = 0; i < listGroups.length; i++) {
    //         items.push(
    //             <FormGroup
    //                 key={i}
    //                 check
    //             // inline
    //             >
    //                 <Input
    //                     type="checkbox"
    //                     value={listGroups[i]}
    //                     defaultChecked={listGroupChecked.includes(listGroups[i])}
    //                     // checked={isCheckAll & listGroupChecked.includes(listGroups[i])}
    //                     // defaultChecked={true}
    //                     onChange={(e) => {
    //                         // alert(e.target.checked);

    //                         const vv = [...listGroupChecked];

    //                         if(e.target.checked) {
    //                             if(!vv.includes(e.target.value)) {
    //                                 vv.push(e.target.value)
    //                                 setListGroupChecked(vv);
    //                                 // setIsCheckAll(true);
    //                             }
    //                         } else {
    //                             if(vv.includes(e.target.value)) {
    //                                 setListGroupChecked(vv.filter(ez => ez !== e.target.value));
    //                             }
    //                         }
    //                     }}
    //                 />
    //                 <Label check>
    //                     {listGroups[i]}
    //                 </Label>
    //             </FormGroup>
    //         )
    //     }

    //     return items;
    // }

    const getCurrTime = () => {
        const ld = new Date();

        // let timeStr = ld.getHours() + ":" + ld.getMinutes();
        let timeStr = ld.toTimeString().substring(0, 5);

        return timeStr;
    }

    const getCurrDate = () => {
        const ld = new Date();

        let dateStr = (ld.getDate() < 10 ? "0" + ld.getDate() : ld.getDate()) + "/" + (ld.getMonth() < 9 ? "0" + (ld.getMonth() + 1) : (ld.getMonth() + 1)) + "/" + ld.getFullYear();

        return dateStr;
    }

    const genListExtInfo = (currSelectedExtsz) => {
        const listItems = currSelectedExtsz.map((item) =>
            <tr key={item.ext}>
                <td>
                    {item.ext}
                </td>
                <td>
                    {item.extName}
                </td>
                <td>
                    {item.numOfOutbound}
                </td>
                <td>
                    {item.numOfOutboundAnswered}
                </td>
                <td>
                    {item.numOfOutboundUnanswered}
                </td>
                <td>
                    {item.outboundTalkingTime}
                </td>
                <td>
                    {item.outboundRingingTime}
                </td>
                <td>
                    {item.avgOutboundTalkingDuration}
                </td>
                <td>
                    {item.avgOutboundRingingDuration}
                </td>
                <td>
                    <FontAwesomeIcon icon={faCircle} color={item.externalPartyNumbers.length === 0 ? bindStatusColorFromStatusText(item.currentProfile) : bindStatusColorFromStatusText('Busy')}/> {item.externalPartyNumbers.length === 0 ? (item.currentProfile === 'Custom 1' ? 'Lunch' : (item.currentProfile === 'Custom 2' ? 'Business Trip' : item.currentProfile)) : 'Busy'}
                </td>
                <td>
                    {item.externalPartyNumbers}
                </td>
            </tr>);

        return listItems;
    }

    return (
        <div>
            {/* <div className='d-flex justify-content-end'>
                <Button className='justify-content-end'
                    color='primary'
                    outline
                    onClick={() => {
                        setModalIsOpen(!modalIsOpen);
                    }}
                >
                    Choose Group
                </Button>
            </div> */}
            {/* <Modal
                isOpen={modalIsOpen}
            >
                <ModalHeader>
                    Chọn Groups
                </ModalHeader>
                <ModalBody>
                    <Form> */}
                        {/* <FormGroup
                            check
                            // inline
                        >
                            <Input type="checkbox" />
                            <Label check>
                                Some input
                            </Label>
                        </FormGroup>
                        <FormGroup
                            check
                            // inline
                        >
                            <Input type="checkbox" 
                                onChange={(e) => {
                                    alert(e.target.checked)
                                }}
                            />
                            <Label check>
                                Some other input
                            </Label>
                        </FormGroup> */}
                        {/* <FormGroup
                            check
                            // inline
                        >
                            <Input
                                type="checkbox"
                                defaultChecked={true}
                                // value={isCheckAll}
                                onChange={(e) => {
                                    if(e.target.checked) {
                                        setListGroupChecked(listGroups);
                                        setIsCheckAll(true);
                                    } else {
                                        setListGroupChecked([]);
                                        setIsCheckAll(false);
                                    }
                                }}
                            />
                            <Label check>
                                {listGroupChecked.length === listGroups.length ? 'Uncheck all' : 'Check all'}
                            </Label>
                        </FormGroup>
                        <hr/> */}

                        {/* {genCheckBox()} */}
                    {/* </Form>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color='primary'
                        onClick={() => {
                            setModalIsOpen(!modalIsOpen);
                            // alert(listGroupChecked);
                            // console.log("HHH: ", listGroupChecked);
                            setCurrDataMatchGroupsSelected(listExtensions);
                        }}
                    >
                        OK
                    </Button>
                    <Button
                        onClick={() => {
                            setModalIsOpen(!modalIsOpen);
                        }}
                    >
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
            <hr/> */}
            <div>
                <div className="row">
                    <div className="col-sm-2 gb-cell gb-c-header d-flex justify-content-center" id="gbc-datetime">
                        {/* 11:30 AM */}
                        {getCurrTime()}
                        <br/>
                        {/* 15/09/2022 */}
                        {getCurrDate()}
                    </div>
                    <div className="col-sm gb-cell gb-c-header d-flex justify-content-center" id="gbc-title">
                        OUTBOUND DASHBOARD 
                        <br/>
                        CONTACT CENTER
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm gb-cell gbc-norm d-flex justify-content-center">
                        <div className="row">
                            <div className="col-sm gbc-value">{commonStatistic.totalCall}</div>
                            <div className="w-100"></div>
                            <div className="col-sm gbc-value-desc">TOTAL CALL</div>
                        </div>
                    </div>
                    <div className="col-sm gb-cell gbc-norm d-flex justify-content-center">
                        <div className="row">
                            <div className="col-sm gbc-value">{commonStatistic.talkingTime}</div>
                            <div className="w-100"></div>
                            <div className="col-sm gbc-value-desc">TALK TIME</div>
                        </div>
                    </div>
                    <div className="col-sm gb-cell gbc-danger d-flex justify-content-center">
                        <div className="row">
                            <div className="col-sm gbc-value">{commonStatistic.waitingTime}</div>
                            <div className="w-100"></div>
                            <div className="col-sm gbc-value-desc">WAITING TIME</div>
                        </div>
                    </div>
                    <div className="col-sm gb-cell gbc-norm d-flex justify-content-center">
                        <div className="row">
                            <div className="col-sm gbc-value">{commonStatistic.numOfAgentsBusy}</div>
                            <div className="w-100"></div>
                            <div className="col-sm gbc-value-desc">AGENTS BUSY</div>
                        </div>
                    </div>
                    <div className="col-sm gb-cell gbc-norm d-flex justify-content-center">
                        <div className="row">
                            <div className="col-sm gbc-value">{commonStatistic.answeredCalls}</div>
                            <div className="w-100"></div>
                            <div className="col-sm gbc-value-desc">ANSWERED</div>
                        </div>
                    </div>
                    <div className="col-sm gb-cell gbc-danger d-flex justify-content-center">
                        <div className="row">
                            <div className="col-sm gbc-value">{commonStatistic.unansweredCalls}</div>
                            <div className="w-100"></div>
                            <div className="col-sm gbc-value-desc">UNANSWERED</div>
                        </div>
                    </div>
                </div>
            </div>
            <hr/>
            <Table
                bordered
                striped
            >
                <thead className='table-info'>
                    <tr>
                        <th>Số ext</th>
                        <th>Tên user</th>
                        <th>Total calls</th>
                        <th>Ans</th>
                        <th>Unans</th>
                        <th>Talk time</th>
                        <th>Ring time</th>
                        <th>Avg talk time</th>
                        <th>Avg ring time</th>
                        <th>Status</th>
                        <th>On a call with</th>
                    </tr>
                </thead>
                <tbody>
                    {currSelectedExts ? genListExtInfo(currSelectedExts) : genListExtInfo(currSelectedExts)}
                </tbody>
            </Table>
        </div>
    );
}

export default GridBoard;
